import {
    trigger,
    state,
    style,
    // transition,
    // animate
} from '@angular/animations';

export const sideWidthNormal = '250px';
export const sideWidthCollapsed = '60px';

export const collapseSidebarTrigger = trigger('collapseSidebarState', [
    state('default', style({
        display: 'block',
        minWidth: sideWidthNormal,
        maxWidth: sideWidthNormal
    })),
    state('collapsed', style({
        display: 'block',
        minWidth: sideWidthCollapsed,
        maxWidth: sideWidthCollapsed
    })),
    // transition('default <=> collapsed', [
    //     animate('300ms ease-out')
    // ])
]);

export const collapseRightTrigger = [
    trigger('collapseRightState', [
        state('default',
            style({
                width: 'calc(100% - ' + sideWidthNormal + ')',
                marginLeft: sideWidthNormal
            })
        ),
        state('collapsed',
            style({
                width: 'calc(100% - ' + sideWidthCollapsed + ')',
                marginLeft: sideWidthCollapsed
            })
        ),
        // transition('collapsed <=> default', [
        //     animate('300ms ease-out')
        // ])
    ]),
    trigger('collapseButtonState', [
        state('default', style({
            transform: 'rotate(0deg)'
        })),
        state('collapsed', style({
            transform: 'rotate(180deg)'
        }))
    ])
];
